var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60009 2.40015H3.00009C2.57574 2.40015 2.16877 2.56872 1.86871 2.86878C1.56866 3.16883 1.40009 3.5758 1.40009 4.00015V13.6001C1.40009 14.0245 1.56866 14.4315 1.86871 14.7315C2.16877 15.0316 2.57574 15.2001 3.00009 15.2001H11.0001C11.4244 15.2001 11.8314 15.0316 12.1315 14.7315C12.4315 14.4315 12.6001 14.0245 12.6001 13.6001V4.00015C12.6001 3.5758 12.4315 3.16883 12.1315 2.86878C11.8314 2.56872 11.4244 2.40015 11.0001 2.40015H9.40009",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60009 2.40029C4.60009 1.97595 4.76866 1.56898 5.06872 1.26892C5.36877 0.968864 5.77574 0.800293 6.20009 0.800293H7.80009C8.22443 0.800293 8.6314 0.968864 8.93146 1.26892C9.23152 1.56898 9.40009 1.97595 9.40009 2.40029C9.40009 2.82464 9.23152 3.23161 8.93146 3.53166C8.6314 3.83172 8.22443 4.00029 7.80009 4.00029H6.20009C5.77574 4.00029 5.36877 3.83172 5.06872 3.53166C4.76866 3.23161 4.60009 2.82464 4.60009 2.40029Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60009 9.6001H4.60809",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60009 12.0002H4.60809",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00009 11.2001L7.80009 12.0001L10.2001 9.6001",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.cc2408eb5876d2d98064bdf3db8f5769.svg";
export { ForwardRef as ReactComponent };